import { Col } from 'antd';
import type { TLandRelation } from '../../../../../../types/api';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../../Style/DatasetInfo.module.scss';
import { LandWarningInfo } from './LandWarningInfo';
import { locationInfoMessages, NEAR_LAND } from './locationDisplay.utils';
import { PointOutOfGridInfo } from './PointOutOfGridInfo';

interface ILocationInfoDisplay {
  hasDatasets: boolean;
  isLocationAvailable: boolean;
  waterDepth?: string | number;
  cellSize?: string | number;
  isWind: boolean;
  landRelation?: TLandRelation | '-';
}

export const LocationInfoDisplay = ({
  hasDatasets,
  isLocationAvailable,
  waterDepth,
  cellSize,
  isWind,
  landRelation,
}: ILocationInfoDisplay) => {
  if (!hasDatasets) {
    return (
      <Col span={18} className={styles.InfoCol}>
        <Label
          label={locationInfoMessages.noDatasetFound}
          className={styles.InfoColLabel}
        >
          {''}
        </Label>
      </Col>
    );
  }

  if (isLocationAvailable) {
    const isNearLand = landRelation === NEAR_LAND;
    const showLandWarning = isNearLand && !isWind;

    return (
      <Col span={12} className={styles.locationInfoContainer}>
        <div className={styles.baseInfo}>
          {isWind ? (
            <div className={styles.InfoColLabel}>{''}</div>
          ) : (
            <Label
              label={locationInfoMessages.waterDepth}
              className={styles.InfoColLabel}
            >
              <div className={styles.InfoLabel}>{waterDepth}</div>
            </Label>
          )}
          <Label
            label={locationInfoMessages.gridCellSize}
            className={styles.InfoColLabelRight}
          >
            <div className={styles.InfoLabel}>{cellSize}</div>
          </Label>
        </div>
        <LandWarningInfo showLandWarning={showLandWarning} />
      </Col>
    );
  }

  return <PointOutOfGridInfo />;
};
